import { z } from "zod";
import { baseEntitySchema } from "./base";

// A daily snapshot of an Airwallex currency balance, captured by the scheduled
// balance sync so balances can be tracked over time. Document id is
// `${accountId}_${date}` (one snapshot per currency per day). `accountId` is the
// currency code.
export const airwallexBalanceSnapshotDataSchema = z.object({
  accountId: z.string(),
  accountName: z.string().optional(),
  kind: z.string().optional(),
  availableBalance: z.number(),
  currentBalance: z.number(),
  currency: z.string().default("USD"),
  // "YYYY-MM-DD" (UTC).
  date: z.string(),
  capturedAt: z.date(),
});

export type AirwallexBalanceSnapshotData = z.infer<
  typeof airwallexBalanceSnapshotDataSchema
>;
export const airwallexBalanceSnapshotSchema = baseEntitySchema.merge(
  airwallexBalanceSnapshotDataSchema,
);
export type AirwallexBalanceSnapshot = z.infer<
  typeof airwallexBalanceSnapshotSchema
>;
